import React, { forwardRef, useImperativeHandle } from 'react'
import { Box, Button, Popover as MuiPopover, Typography } from '@mui/material'
import { CalendarIcon } from '@mui/x-date-pickers'
import { theme } from 'theme'
import { IDateRangeAPI } from '../types'

interface IDateRangePopover {
  title?: string
  label: string
  children: React.ReactElement
}

const Popover = forwardRef<IDateRangeAPI | undefined, IDateRangePopover>(
  ({ title = 'Select time range', label, children }, ref) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)

    useImperativeHandle(ref, () => ({
      handlePopoverClose
    }))

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget)
    }

    const handlePopoverClose = () => {
      setAnchorEl(null)
    }

    const isOpen = Boolean(anchorEl)

    return (
      <>
        <Box>
          <Typography variant="body2" sx={{ color: '#272F30', marginBottom: '4px' }}>
            {title}
          </Typography>
          <Button
            onClick={handlePopoverOpen}
            variant="text"
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: '#1F2424',
              border: `2px solid ${theme.palette['surface']['base']}`,
              borderRadius: '8px',
              padding: '8px 12px'
            }}
          >
            <Typography variant="body2">{label}</Typography>
            <CalendarIcon sx={{ color: theme.palette['text-color']['newSecondary'] }} />
          </Button>
        </Box>
        <MuiPopover
          id="popover"
          open={isOpen}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          onClose={handlePopoverClose}
        >
          {children}
        </MuiPopover>
      </>
    )
  }
)

Popover.displayName = 'DateRangePopover'

export { Popover }
